import { useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import "./NavigationBarClean.css";
import SearchModal from "./SearchModal";

function NavigationBarClean() {
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const { instance, accounts } = useMsal();
  const history = useHistory();

  const account = accounts[0];
  const isAuthenticated = accounts.length > 0;

  // Extract user initials
  const getInitials = () => {
    if (!account || !account.name) return "";
    const nameParts = account.name.split(" ");
    if (nameParts.length >= 2) {
      return `${nameParts[0].charAt(0)}${nameParts[nameParts.length - 1].charAt(0)}`.toUpperCase();
    }
    return nameParts[0].charAt(0).toUpperCase();
  };

  const handleSignOut = () => {
    instance.logoutRedirect({
      account: accounts[0],
      postLogoutRedirectUri: "/",
    });
  };

  const handleSearchClick = () => {
    setIsSearchModalOpen(true);
  };

  const handleCloseSearchModal = () => {
    setIsSearchModalOpen(false);
  };
  
  const handleAccessManagement = () => {
    setIsProfileDropdownOpen(false);
    history.push('/access-management');
  };

  const handleAnalytics = () => {
    setIsProfileDropdownOpen(false);
    history.push('/analytics');
  };
  
  const handleScroll = () => {
    document.body.scrollTop = 0;
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light navbar-clean">
      <div className="container-fluid p-0 h-100">
        {/* Logo */}
        <Link to="/" className="navbar-brand logo-container h-100 d-flex align-items-center" onClick={handleScroll}>
             <img src="./SpiritLogo.png" alt="Cargo Logo" className="logo-clean" />
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler me-3"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          style={{ border: 'none' }}
        >
           <span className="navbar-toggler-icon" style={{
            backgroundImage: isOpen
              ? "url('/images/icon_navigation_menuopen.svg')"
              : "url('/images/icon_navigation_menu.svg')",
          }}></span>
        </button>

        {/* Navbar Items */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav mb-2 mb-lg-0 ms-3">
             <li className="nav-item">
              <Link className="nav-link" to="/about-us" onClick={() => setIsOpen(false)}>About Us</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#services" onClick={() => setIsOpen(false)}>Services</Link>
            </li>
          </ul>

          {/* Right Side Search */}
          <div className={`d-flex align-items-center nav-item-search ms-lg-auto ${isAuthenticated ? 'has-profile' : ''}`}>
             <a href="#" className="nav-link search-btn d-flex align-items-center" onClick={(e) => { e.preventDefault(); handleSearchClick(); }}>
                <img src="./search 1.svg" className="search-icon-clean" alt="Search" />
                <span className="ms-2">Search</span>
             </a>
          </div>

          {/* User Profile Dropdown */}
          {isAuthenticated && (
            <div className="profile-container ms-3 position-relative">
              <div 
                className="profile-circle d-flex align-items-center justify-content-center"
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                onMouseEnter={() => setIsProfileDropdownOpen(true)}
                style={{ cursor: 'pointer' }}
              >
                {getInitials()}
              </div>
              
              {isProfileDropdownOpen && (
                <div 
                  className="profile-dropdown"
                  onMouseLeave={() => setIsProfileDropdownOpen(false)}
                >
                  <div className="profile-dropdown-header">
                    {account?.name}
                  </div>
                  <div className="profile-dropdown-divider"></div>
                  <button 
                    className="profile-dropdown-item" 
                    onClick={handleAccessManagement}
                  >
                    Access Management
                  </button>
                  <button 
                    className="profile-dropdown-item" 
                    onClick={handleAnalytics}
                  >
                    Analytics
                  </button>
                  <button 
                    className="profile-dropdown-item" 
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <SearchModal isOpen={isSearchModalOpen} onClose={handleCloseSearchModal} />
    </nav>
  );
}

export default NavigationBarClean;
